import React from 'react';
import { motion } from 'framer-motion';

const ConclavePrayer: React.FC = () => {
  const prayer = {
    title: "Prière pour le Conclave",
    content: [
      "Dieu, père miséricordieux, qui as révélé ton amour dans ton Fils Jesus Christ, et l'as répandu sur nous dans l'Esprit Saint Consolateur, nous te confions aujourd'hui le destin du monde et de chaque homme. Penche-toi sur nos péchés, guéris notre faiblesse, vaincs tout mal, fais que tous les habitants de la terre fassent l'expérience de ta miséricorde, afin qu'en toi, Dieu un et trine, ils trouvent la source de l'espérance.",
      "Nous te confions particulièrement notre Pape Léon XIV, guide-le par ton Esprit Saint dans sa mission au service de l'Église.",
      "Par notre Seigneur Jésus‑Christ, qui vit et règne avec toi dans l'unité du Saint‑Esprit, pour les siècles des siècles.",
      "Amen."
    ]
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.3 }}
      className="mt-8 sm:mt-16 mb-8 sm:mb-12 bg-gray-800 bg-opacity-70 rounded-lg p-4 sm:p-6 shadow-xl max-w-3xl mx-2 sm:mx-auto"
    >
      <div className="mb-4 sm:mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-yellow-500 text-center">
          {prayer.title}
        </h2>
      </div>
      
      <div className="text-gray-300 space-y-4 italic">
        {prayer.content.map((paragraph, index) => (
          <p key={index} className={index === prayer.content.length - 1 ? "text-right font-semibold" : ""}>
            {paragraph}
          </p>
        ))}
      </div>
    </motion.div>
  );
};

export default ConclavePrayer;
